var render = function () {
  var _vm$localAppraisal$do, _vm$report;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportAppraisalCard.number'),
      "readonly": ""
    },
    model: {
      value: _vm.localAppraisal.title,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal, "title", $$v);
      },
      expression: "localAppraisal.title"
    }
  })], 1), _vm.canReadAppraisal ? _c('v-col', {
    staticClass: "d-flex justify-end align-start"
  }, [_c('div', [_vm.localAppraisal.status === _vm.RequestStatusEnum.DRAFT && _vm.localAppraisal.lastSharedContent ? _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.isSendDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v(" mdi-send-variant-outline ")]), _vm._v(" " + _vm._s(_vm.$t("submit")) + " ")], 1) : _vm._e(), _vm.canUpdateAppraisal ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.openUpdateDialog();
      }
    }
  }) : _vm._e(), _vm.canDeleteAppraisal ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "icon": "mdi-trash-can",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.openDeleteDialog();
      }
    }
  }) : _vm._e(), _vm.canShareContent && !_vm.hideSharingLink ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "icon": "mdi-link-variant",
      "small": "",
      "outlined": "",
      "disabled": !_vm.localAppraisal.lastSharedContent
    },
    on: {
      "click": function click() {
        return _vm.sharedContentSideCardItem = _vm.localAppraisal.lastSharedContent;
      }
    }
  }) : _vm._e(), !_vm.hideGoToDetail ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "icon": "mdi-open-in-new",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.goToDetail();
      }
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1), _c('v-row', {
    staticClass: "mb-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('created'),
      "readonly": ""
    },
    model: {
      value: _vm.localAppraisal.timestamp.createdReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal.timestamp, "createdReadable", $$v);
      },
      expression: "localAppraisal.timestamp.createdReadable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('responded'),
      "readonly": ""
    },
    model: {
      value: _vm.localAppraisal.respondedDate,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal, "respondedDate", $$v);
      },
      expression: "localAppraisal.respondedDate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_vm.canReadAppraisal ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportAppraisalCard.date'),
      "readonly": "",
      "type": "date"
    },
    model: {
      value: _vm.localAppraisal.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal, "dateFormable", $$v);
      },
      expression: "localAppraisal.dateFormable"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.statusItems,
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportAppraisalCard.status'),
      "chips": "",
      "readonly": "",
      "small-chips": "",
      "append-icon": ''
    },
    model: {
      value: _vm.localAppraisal.status,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal, "status", $$v);
      },
      expression: "localAppraisal.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.TotalLossTypeItems,
      "label": _vm.$t('objects.appraisal.totalLoss'),
      "chips": "",
      "readonly": "",
      "small-chips": "",
      "append-icon": ''
    },
    model: {
      value: _vm.localAppraisal.totalLoss,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal, "totalLoss", $$v);
      },
      expression: "localAppraisal.totalLoss"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": _vm.localAppraisal.totalNet.toLocaleString('de-DE', {
        style: 'currency',
        currency: _vm.localAppraisal.currency
      }),
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportAppraisalCard.total'),
      "readonly": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": (_vm.localAppraisal.residualValueNet || 0).toLocaleString('de-DE', {
        style: 'currency',
        currency: _vm.localAppraisal.currency
      }),
      "label": _vm.$t('objects.appraisal.residualValueNet'),
      "readonly": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": (_vm.localAppraisal.replacementValueNet || 0).toLocaleString('de-DE', {
        style: 'currency',
        currency: _vm.localAppraisal.currency
      }),
      "label": _vm.$t('objects.appraisal.replacementValueNet'),
      "readonly": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": (_vm.localAppraisal.diminishedValueNet || 0).toLocaleString('de-DE', {
        style: 'currency',
        currency: _vm.localAppraisal.currency
      }),
      "label": _vm.$t('objects.appraisal.diminishedValueNet'),
      "readonly": ""
    }
  })], 1)], 1), _c('v-row', [_vm.localAppraisal.seller ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "mb-2 grey--text text--darken-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.seller")) + " ")]), _c('invoice-party-sheet', {
    attrs: {
      "invoice-party": _vm.localAppraisal.seller,
      "color": "white"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.localAppraisal.document ? [_vm.localAppraisal.document] : [],
      "item-text": "name",
      "label": _vm.$t('common.nouns.appendix'),
      "readonly": "",
      "chips": "",
      "small-chips": "",
      "append-icon": ''
    },
    model: {
      value: _vm.localAppraisal.document,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal, "document", $$v);
      },
      expression: "localAppraisal.document"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.canUpdateAppraisal ? _c('select-assignees', {
    attrs: {
      "css": "width: 100%",
      "partnerId": _vm.localAppraisal.partnerId,
      "outlined": false,
      "dense": false,
      "solo": false
    },
    on: {
      "input": _vm.onAssigneesUpdate,
      "added": _vm.onAssigneesAdded,
      "removed": _vm.onAssigneesRemoved
    },
    model: {
      value: _vm.localAppraisal.assignees,
      callback: function callback($$v) {
        _vm.$set(_vm.localAppraisal, "assignees", $$v);
      },
      expression: "localAppraisal.assignees"
    }
  }) : _vm._e()], 1)], 1), _c('v-divider'), _c('v-row', {
    staticClass: "align-center mt-2 mb-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-1 text-subtitle-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.positions", {
    count: _vm.localAppraisal.lineItems.length
  })) + " ")])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.showPositions = !_vm.showPositions;
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showPositions ? "mdi-chevron-up" : "mdi-chevron-down"))])], 1)], 1)], 1), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPositions,
      expression: "showPositions"
    }]
  }, [_c('v-sheet', {
    attrs: {
      "rounded": "",
      "color": "grey lighten-4 mb-2"
    }
  }, [_c('line-items-form', {
    attrs: {
      "value": _vm.localAppraisal,
      "showQuantity": "",
      "readonly": ""
    }
  })], 1)], 1)]), _c('v-divider'), _c('v-row', {
    staticClass: "align-center mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-1 text-subtitle-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.documentId", {
    count: _vm.localAppraisal.documentId ? 1 : 0
  })) + " ")])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.showDocument = !_vm.showDocument;
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showDocument ? "mdi-chevron-up" : "mdi-chevron-down"))])], 1)], 1)], 1), _c('v-expand-transition', [_c('v-sheet', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showDocument,
      expression: "showDocument"
    }],
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_vm.localAppraisal && _vm.localAppraisal.isDocumentLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : (_vm$localAppraisal$do = _vm.localAppraisal.document) !== null && _vm$localAppraisal$do !== void 0 && _vm$localAppraisal$do.url ? _c('iframe', {
    attrs: {
      "src": _vm.localAppraisal.document.url,
      "width": "100%",
      "height": "800px"
    }
  }) : _c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-outline",
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportAppraisalCard.noDocumentText'),
      "color": "transparent"
    }
  })], 1)], 1), _c('partner-report-appraisal-update-dialog', {
    attrs: {
      "appraisal": _vm.localAppraisal
    },
    on: {
      "update:appraisal": [function ($event) {
        _vm.localAppraisal = $event;
      }, _vm.emitUpdateAppraisal]
    },
    model: {
      value: _vm.isUpdateDialog,
      callback: function callback($$v) {
        _vm.isUpdateDialog = $$v;
      },
      expression: "isUpdateDialog"
    }
  }), _vm.report ? _c('report-appraisal-estimate-send-dialog', {
    attrs: {
      "appraisal": _vm.localAppraisal,
      "report": _vm.report
    },
    on: {
      "update:appraisal": function updateAppraisal($event) {
        _vm.localAppraisal = $event;
      }
    },
    model: {
      value: _vm.isSendDialog,
      callback: function callback($$v) {
        _vm.isSendDialog = $$v;
      },
      expression: "isSendDialog"
    }
  }) : _vm._e(), _vm.sharedContentSideCardItem ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.sharedContentSideCardItem,
      "referenceCategories": [_vm.ResourceEnum.DOCUMENT, _vm.ResourceEnum.RENTAL, _vm.ResourceEnum.APPRAISAL, _vm.ResourceEnum.REPAIR_ESTIMATE, _vm.ResourceEnum.CLEARANCE, _vm.ResourceEnum.CLEARANCE_APPROVAL],
      "suggested": (_vm$report = _vm.report) === null || _vm$report === void 0 ? void 0 : _vm$report.suggestedRefs,
      "hideSuggested": false,
      "filters": _vm.filters
    },
    on: {
      "close": function close($event) {
        _vm.sharedContentSideCardItem = null;
      }
    }
  }) : _vm._e(), _vm.isDeleteDialogActive ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }